export default __webpack_public_path__ + "static/media/SE_Logo_Light.3e3f3887.png";